import PropTypes from 'prop-types';

export default {
  nodeId: PropTypes.string.isRequired,
  depth: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  selected: PropTypes.bool,
  progress: PropTypes.bool,
  expanded: PropTypes.bool,
  noChildren: PropTypes.bool,
  onSelect: PropTypes.func,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  toggleIcon: PropTypes.element,
  setExpanded: PropTypes.func,
  setSelected: PropTypes.func,
  setProgress: PropTypes.func,
  getIsVisible: PropTypes.func,
  getIsExpanded: PropTypes.func,
  getIsProgress: PropTypes.func,
};
